import { call, put, takeEvery } from "redux-saga/effects"
import {
  DELETE_FILE,
  EDIT_FILE,
  GET_FILE_REQUIREMENT,
  GET_LIST_AREA,
  GET_LIST_FILE_TYPE,
  SAVE_FILE,
} from "./actionTypes"
import {
  getFilesRequirementSuccess,
  getFilesRequirementFail,
  getTypesAreaSuccess,
  getTypesAreaFail,
  getTypesFilesSuccess,
  getTypesFilesFail,
  updateFileFail,
  updateFileSuccess,
  deleteFileFail,
  deleteFileSuccess,
  saveFileFail,
  saveFileSuccess,
} from "./actions"
import service from "../../api/fileRequirementService"
function* fetchFilesRequirement({ payload: filter }) {
  try {
    const response = yield call(service.getFilesRequirement, filter.filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(getFilesRequirementFail(error))
    } else {
      yield put(getFilesRequirementSuccess(response))
    }
  } catch (error) {
    yield put(getFilesRequirementFail(error))
  }
}

function* fetchTypesArea({ payload: filter }) {
  try {
    const response = yield call(service.getTypeList, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(getTypesAreaFail(error))
    } else {
      yield put(getTypesAreaSuccess(response))
    }
  } catch (error) {
    yield put(getTypesAreaFail(error))
  }
}

function* fetchTypesFiles({ payload: filter }) {
  try {
    const response = yield call(service.getTypeList, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(getTypesFilesFail(error))
    } else {
      yield put(getTypesFilesSuccess(response))
    }
  } catch (error) {
    yield put(getTypesFilesFail(error))
  }
}
function* fetchSaveFile({ payload: filter }) {
  try {
    const response = yield call(service.saveFile, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(saveFileFail(error))
    } else {
      yield put(saveFileSuccess(response))
    }
  } catch (error) {
    yield put(saveFileFail(error))
  }
}
function* fetchUpdateFile({ payload: filter }) {
  try {
    const response = yield call(service.updateFile, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(updateFileFail(error))
    } else {
      yield put(updateFileSuccess(response))
    }
  } catch (error) {
    yield put(updateFileFail(error))
  }
}
function* fetchDeleteFiles({ payload: filter }) {
  try {
    const response = yield call(service.deleteFile, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(deleteFileFail(error))
    } else {
      yield put(deleteFileSuccess(response))
    }
  } catch (error) {
    yield put(deleteFileFail(error))
  }
}
function* fileRequirementSaga() {
  yield takeEvery(GET_FILE_REQUIREMENT, fetchFilesRequirement)
  yield takeEvery(GET_LIST_AREA, fetchTypesArea)
  yield takeEvery(GET_LIST_FILE_TYPE, fetchTypesFiles)

  yield takeEvery(EDIT_FILE, fetchUpdateFile)
  yield takeEvery(DELETE_FILE, fetchDeleteFiles)
  yield takeEvery(SAVE_FILE, fetchSaveFile)
}

export default fileRequirementSaga
